const configCompileProvider = ($compileProvider, ENV) => {
	if (ENV === 'production') {
		$compileProvider.debugInfoEnabled(false);
	}
};
configCompileProvider.$inject = ['$compileProvider', 'ENV'];
export default configCompileProvider;
